import React from 'react';
import { StudentsDataTable } from '@magoosh/b2b/app/organisms/students_data_table';

export const Students: React.FC = () => (
  <StudentsDataTable />
);
